// Resolve um dataURL PNG para o logotipo da revenda.
// 1) Tenta PNG/JPG direto (via fetch → dataURL)
// 2) Tenta SVG (via fetch → rasteriza em canvas → PNG dataURL)
// 3) Fallback: null (sem logo)

// Ajuste a lista conforme sua infra multi-tenant
const KNOWN_LOGO_CANDIDATES = [
  '/branding/logo.png',
  '/branding/logo.jpg',
  '/branding/logo.svg',
  '/logo.png',
  '/logo.jpg',
  '/logo.svg',
];

async function fetchAsDataURL(url) {
  const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
  if (!res.ok) throw new Error(`HTTP ${res.status} for ${url}`);
  const blob = await res.blob();
  return await new Promise((resolve) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.readAsDataURL(blob);
  });
}

async function fetchSvgAsText(url) {
  const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
  if (!res.ok) throw new Error(`HTTP ${res.status} for ${url}`);
  return await res.text();
}

// Injeta width/height no SVG para dar dimensões previsíveis no canvas
function ensureSvgSize(svgText, fallbackW = 360, fallbackH = 96) {
  if (!svgText) return '';
  const hasW = /width=/i.test(svgText);
  const hasH = /height=/i.test(svgText);
  if (hasW && hasH) return svgText;
  // adiciona atributos no <svg ...>
  return svgText.replace(
    /<svg([^>]+)>/i,
    (m, attrs) => `<svg${attrs} width="${fallbackW}" height="${fallbackH}">`
  );
}

async function svgTextToPngDataURL(svgText) {
  const sanitized = ensureSvgSize(svgText);
  // Usa data URL para evitar CORS no onload
  const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(sanitized)}`;
  const img = new Image();
  img.decoding = 'async';
  img.crossOrigin = 'anonymous';

  await new Promise((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = (e) => reject(e);
    img.src = svgDataUrl;
  });

  const w = img.naturalWidth || 360;
  const h = img.naturalHeight || 96;
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, w, h);
  ctx.drawImage(img, 0, 0, w, h);
  return canvas.toDataURL('image/png'); // jsPDF lida melhor com PNG
}

export default async function getResolvedLogoUrl(customCandidates) {
  const candidates = Array.isArray(customCandidates) && customCandidates.length
    ? customCandidates
    : KNOWN_LOGO_CANDIDATES;

  // 1) PNG/JPG primeiro (melhor caminho para jsPDF)
  for (const url of candidates) {
    const lower = url.toLowerCase();
    if (lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
      try {
        return await fetchAsDataURL(url);
      } catch (_) { /* tenta o próximo */ }
    }
  }

  // 2) SVG → PNG via canvas
  for (const url of candidates) {
    if (url.toLowerCase().endsWith('.svg')) {
      try {
        const svg = await fetchSvgAsText(url);
        return await svgTextToPngDataURL(svg);
      } catch (_) { /* tenta o próximo */ }
    }
  }

  // 3) falhou — sem logo
  return null;
}
